import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const EditExpense = ({ modalOpen, setModalOpen, expense }) => {
  const { requestWithAuth } = useAuth();
  const [submittingForm, setSubmittingForm] = useState(false);
  const [data, setData] = useState({});
  const [branches, setBranches] = useState([]);

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const fetchBranches = async () => {
    try {
      const data = await requestWithAuth(
        `/company/branches/?pageSize=100`,
        "GET"
      );
      setBranches(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
    }
  };

  const recordExpense = async (e) => {
    e.preventDefault();

    Swal.fire({
      icon: "question",
      title: "Are you sure you want to proceed?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setSubmittingForm(true);
          const body = JSON.stringify(data);

          const response = await requestWithAuth(
            `/company/expense/${expense?.id}/`,
            "PUT",
            body,
            {
              "Content-Type": "application/json",
            }
          );
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Expense Updated Successfully",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {

          toast.error("Something went wrong!");
        } finally {
          setSubmittingForm(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="New Expense"
      >
        <form onSubmit={(e) => recordExpense(e)}>
          <div className="grid grid-cols-2 gap-5">
            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Branch
              </label>
              <select
                name="branch"
                onChange={(e) => handleFormChange(e)}
                id=""
                required
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              >
                <option value="">Select Branch</option>
                {branches.map((branch, index) => (
                  <option key={index} value={branch.id} selected={expense?.branch == branch?.name}>
                    {branch.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Expense Date
              </label>
              <input
                type="date"
                name="date"
                required
                value={data?.date || expense?.date}
                onChange={(e) => handleFormChange(e)}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Mode of payment
              </label>
              <select
                name="payment_mode"
                onChange={(e) => handleFormChange(e)}
                id=""
                required
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              >
                <option value="">Select Mode of Payment</option>
                <option value="Cash" selected={expense?.payment_mode == "Cash"}>Cash</option>
                <option value="Cheque" selected={expense?.payment_mode == "Cheque"}>Cheque</option>
                <option value="Mobile Money" selected={expense?.payment_mode == "Mobile Money"}>Mobile Money</option>
              </select>
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Expense Amount
              </label>
              <input
                type="number"
                step="0.01"
                required
                min="0"
                name="amount"
                value={data?.amount || expense?.amount}
                onChange={(e) => handleFormChange(e)}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Expense Narration
              </label>
              <input
                type="text"
                name="expense_narration"
                required
                value={data?.expense_narration || expense?.expense_narration}
                onChange={(e) => handleFormChange(e)}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              />
            </div>
          </div>
          <div className="flex items-center justify-end gap-6 mt-7">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              Close
            </div>
            {submittingForm ? (
              <div className="bg-blue-400 flex items-center gap-2 rounded px-4 py-2 text-white ">
                <RotatingLines strokeColor="white" height="12" width="12" />{" "}
                Submitting
              </div>
            ) : (
              <button className="bg-blue-500 hover:bg-blue-600 rounded px-4 py-2 text-white ">
                Submit Form
              </button>
            )}
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default EditExpense;
